import Head from 'components/Head'
import Navbar from 'components/Navbar'
import Footer from 'components/Footer'
import HelpPage from 'components/HelpContainer'
import company from 'config/company.json'
import { withI18nStaticProps } from 'utils/request/ssg'
import {
  NavigationProvider,
  useTranslation
} from '@sailogy/shipwright'
import { K, i18nPath } from 'i18n/help_imprint'


const ImprintPage: React.FC = () => {
  const t = useTranslation<K>()

  return (
    <NavigationProvider path="/help_imprint">
      <Head
        title={t('Imprint')}
        description={`${company.name} ${t('Imprint')}`}
      />
      <Navbar />
      <HelpPage title={t('Imprint')} active="imprint">
        <article>
          <section>
            <h3>{t('Name and Address')}</h3>
            <p>
              Master Yachting GmbH
              <br />
              {company.address}
            </p>
            <p>
              Tel
              {company.phone}
            </p>

            <h3>{t('E-mail address')}</h3>
            <p>{company.email}</p>

            <h3>{t('Web Address')}</h3>
            <p>{company.website}</p>

            <h3>{t('Authorized Managing Director')}</h3>
            <p>
              Michael Müller
            </p>

            <h3>{t('Responsible for content according to paragraph')}</h3>
            <p>
              Michael Müller
              / Master Yachting Deutschland
            </p>

            <h3>{t('Register Entry')}</h3>
            <p>
              {`${t('Register court')}: Amtsgericht Würzburg`}
              <br />
              {`${t('Registration number')}: HRB 3761`}
              <br />
              {`${t('Tax identification number')}: DE 134176108`}
            </p>

            <h3>{t('Legal Validity')}</h3>
            <p>{t('By visiting the {SITE_NAME} website, you acknowledge the terms of our disclaimer. If parts or individual formulations of this disclaimer do not, no longer or do not fully comply with the applicable legal situation, this does not affect the validity of the remaining provisions.', { SITE_NAME: company.name })}</p>

            <h3>{t('Image Source')}</h3>
            <p>
              33062396 © EXTREMFOTOS
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              51954100 © milosk50
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              51823520 © DEMIX
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              100865996 © massimocampanari
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              133200457 © kite_rin
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              623481 © Momentum
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              124276102 © Andrea
              {' '}
              <a href="http://Fotolia.com">Fotolia.com</a>
              <br />
              Sascha Koch
              <br />
              Christian Lendl
              <br />
              Moorings and photographers working for Moorings
              <br />
              Sunsail and Sunsail photographers
            </p>
          </section>
        </article>
      </HelpPage>
      <Footer />
    </NavigationProvider>
  )
}

// Build SSG pages for each language
export const getStaticProps = withI18nStaticProps(i18nPath)

export default ImprintPage
